/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Collapse Bar Icon component.
 */
export const SideNavCollapseBarIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.25 1C3.56002 1.00045 3 1.55992 3 2.25V21.9561C3.00031 22.6459 3.56021 23.2056 4.25 23.2061H19.6426C20.3327 23.2061 20.8923 22.6461 20.8926 21.9561V2.25C20.8926 1.55965 20.3329 1 19.6426 1H4.25ZM7.42773 21.7061H4.5V2.5H7.42773V21.7061ZM19.3926 21.7061H8.92773V2.5H19.3926V21.7061ZM11.5156 12.1025L15.7129 16.416L16.6924 15.4102L13.4746 12.1025L16.6924 8.79492L15.7129 7.78906L11.5156 12.1025Z' fill={iconColor} />
    </svg>
  );
};

export default SideNavCollapseBarIcon;
